import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from "../../app.component";
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {EmailRegex} from "../../const/utils";
import {RouterLinks} from "../../enums/router-links";
import {NavigationEnd, Router} from "@angular/router";
import {ModalTypes} from "../../enums/modal-types";
import {ModalTemplates} from "../../enums/modal-templates";

@Component({
  selector: 'app-password-reminder',
  templateUrl: './password-reminder.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./password-reminder.component.less']
})
export class PasswordReminderComponent implements OnInit {
  reminderForm!: FormGroup;
  submitted = false;
  global_texts: any = null;
  page_texts: any = null;

  constructor(
    public app: AppComponent,
    private formBuilder: FormBuilder,
    private router: Router,
  ) {
    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //       this.initializeComponentRemind();
    //   }
    // });
  }

  get f() {
    return this.reminderForm.controls;
  }

  ngOnInit(): void {
    this.initializeComponentRemind();
  }

  initializeComponentRemind() {
    // Get the global texts
    this.app.sharedHelper.getGlobalTexts().subscribe((texts: any) => {
      console.log("texts ==> ", texts);
      this.global_texts = texts;
      this.page_texts = this.global_texts.password_reminder_page;

      // Initialize the form
      this.reminderForm = this.formBuilder.group({
        email: ['', [Validators.required, Validators.pattern(EmailRegex)]]
      });
    });
  }

  onSubmit() {
    // Display the form values
    console.log("this.reminderForm.value ==> ", this.reminderForm.value);
    this.submitted = true;

    // Stop here if form is invalid
    if (this.reminderForm.invalid) return;

    this.app.apiService.forgotPassword(this.reminderForm.value.email).subscribe((response: any) => {
      console.log("response ==> ", response);
      if (response?.data) {
        // Show modal with success message
        this.app.dialogService.confirmThis('', this.global_texts.modals?.email_sended?.message, ModalTypes.Alert, ModalTemplates.Default, () => {
          // Redirect to login page
          this.router.navigate([RouterLinks.Login]);
        }, () => {});
      }
    });

  }

  protected readonly RouterLinks = RouterLinks;
}
